import BaseRouteCard from "./BaseRouteCard";

export default function MovableRouteCard({
    route,
    cardHeight,
    isHovered = false,
    index = 0,
    count = 1,
}) {
    const isFirst = index === 0;
    const reverse = count - index;
    const translateY = isHovered ? reverse * -cardHeight : 0;

    return <div className={cn('direction-card', isFirst && 'first')}
                style={{
                    transform: `translate(0, ${translateY}px)`,
                    zIndex: count - index,
                    top: isHovered ? 0 : index * 10 + 'px'
                }}>
        <BaseRouteCard
            route={route}
            showPlane={index !== 0}
        />
    </div>
}